export default "__VITE_ASSET__5adda8fb__"